export const INITIAL_PAGE_SIZES = [5, 10, 20, 30, 40, 50];
